$(document).ready(function(){
  $(".mv_pt_custom_info_icon, .mv_pt_custom_info_text").click(function(){
    $(".mv_pt_custom_info_text").toggle();
  });
  $(".mv_pt_accordian_header").click(function(){
    if ($(this).next().hasClass("active")){
      $(this).next().removeClass("active").slideUp(300);
      $(this).find(".mv_pa_header_minus").addClass("mv_pa_header_plus");
    }
    else {
      $(".mv_pt_accordian_body").removeClass("active").slideUp(300);
      $(".mv_pa_header_minus").addClass("mv_pa_header_plus");
      $(this).next(".mv_pt_accordian_body").addClass("active").slideDown(300);
      $(this).find(".mv_pa_header_minus").removeClass("mv_pa_header_plus");
    }
  });
});
